import Config from '../../../config';

export function selectTabSwitch(cube: CubeNode): void {
    let selectType: number = Config.get({
        moduleName: 'select',
        key: 'selectType'
    });

    cube.jView.find('.J_lockSelect')
        .children()
        .removeClass('active')
        .eq(selectType)
        .addClass('active');
}
